#import "../fragments/activity-for-modal-fragment.graphql"

mutation ActivityUpdate($input: ActivityUpdateInput!) {
    activityUpdate(input: $input) {
        activity {
            ...ActivityModalFragment
        }
    }
}
